var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function emailVerifyCallback(settings) {
  return __async(this, null, function* () {
    const authClient = settings.getAuthClient();
    const idxOptions = {
      exchangeCodeForTokens: false
      // we handle this in interactionCodeFlow.js
    };
    const meta = yield authClient.idx.getSavedTransactionMeta();
    if (!meta || !meta.interactionHandle) {
      const messages = {
        type: "array",
        value: [
          // terminal-return-otp-only-no-location.json
          {
            "message": "Enter the OTP in your original browser or device.",
            "i18n": {
              "key": "idx.enter.otp.in.original.tab"
            },
            "class": "INFO"
          }
        ]
      };
      const resp = {
        neededToProceed: [],
        // OKTA-382410 so bad that has to leverage rawIdxState
        rawIdxState: {
          messages
        },
        context: {
          messages
        }
      };
      return resp;
    }
    const otp = settings.get("otp");
    const idxResponse = yield authClient.idx.proceed(__spreadProps(__spreadValues({}, idxOptions), {
      otp
    }));
    return idxResponse;
  });
}
export { emailVerifyCallback };
